import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./EnrichedIcon.less";
import type { IEnrichedIconProps } from "./EnrichedIcon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 116 116"
    {...props}
  >
    <path
      fill="#002F77"
      d="M58 109c28.167 0 51-22.833 51-51 0-28.166-22.833-51-51-51C29.834 7 7 29.834 7 58c0 28.167 22.834 51 51 51"
    />
    <path
      fill="#00D8D8"
      d="M108.57 46.16a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5M99.62 20.06l3.94-3.94c.59-.59.59-1.54 0-2.12a1.49 1.49 0 0 0-2.12 0l-3.94 3.94L93.56 14a1.49 1.49 0 0 0-2.12 0 1.49 1.49 0 0 0 0 2.12l3.94 3.94L91.44 24a1.49 1.49 0 0 0 0 2.12c.29.29.68.44 1.06.44s.77-.15 1.06-.44l3.94-3.94 3.94 3.94c.29.29.68.44 1.06.44s.77-.15 1.06-.44c.59-.59.59-1.54 0-2.12z"
    />
    <path fill="#D8FFFF" d="M6.57 88.87a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7" />
    <path
      fill="#00D8D8"
      d="M42.52 102.51h-5.57v-5.57c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v5.57h-5.57c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5h5.57v5.57c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5v-5.57h5.57c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5M11.57 70.72c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6m0-10c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4M58 15.85c13.32 0 24.11 10.8 24.11 24.11 0 10.74-15.67 31.59-21.75 39.26A3.02 3.02 0 0 1 58 80.37c-.92 0-1.79-.42-2.36-1.15-6.07-7.68-21.74-28.53-21.74-39.26 0-13.32 10.8-24.11 24.11-24.11z"
    />
    <path
      fill="#0597A3"
      d="M58 52.02c6.66 0 12.06-5.4 12.06-12.06S64.66 27.9 58 27.9s-12.06 5.4-12.06 12.06S51.34 52.02 58 52.02"
    />
    <path
      fill="#D8FFFF"
      d="M70.83 93.82a2.24 2.24 0 0 1-2.18-1.71c-.3-1.2.43-2.42 1.63-2.72 0 0 .5-.13 2.72-.6 9.71-2.34 16.28-6.98 16.28-11.53 0-3.1-3.2-6.34-9.01-9.12-1.79-.86-2.34-1.06-2.37-1.07a2.265 2.265 0 0 1-1.39-2.85c.4-1.16 1.64-1.8 2.81-1.42.16.05.85.3 2.89 1.28 9.56 4.58 11.57 9.7 11.57 13.18 0 6.99-7.4 12.94-19.78 15.92-2.06.44-2.59.57-2.63.58-.18.04-.36.07-.54.07zM62.23 91.2l-.12-.12-5.09-5.09c-.88-.88-2.3-.88-3.18 0s-.88 2.3 0 3.18l1.24 1.24c-13.96-.65-28.35-5.87-28.35-13.16 0-3.04 3.06-6.12 9.08-9.16 2-1.01 2.6-1.24 2.6-1.24 1.17-.41 1.79-1.7 1.38-2.87a2.257 2.257 0 0 0-2.87-1.38c-.17.06-.9.34-3.13 1.47-7.78 3.92-11.56 8.23-11.56 13.18 0 9.47 14.29 16.99 33 17.67l-1.39 1.39a2.25 2.25 0 0 0 1.59 3.84c.57 0 1.15-.22 1.59-.66l6.75-6.75-1.53-1.53z"
    />
  </svg>
);
const SvgEnrichedIconTrackingBrand = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IEnrichedIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("enriched-icon bds-enriched-icon", className, {
        ["bds-enriched-icon-" + size]: size,
        ["enriched-icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgEnrichedIconTrackingBrand);
export default Memo;
